module.exports = __webpack_public_path__ + "img/sumeru.88d3564c.jpg";